import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "m10 10.88 3.71-3.71 1.06 1.06L10 13 5.23 8.23l1.06-1.06z" }));
export default SvgChevron;
